import { PERSONA_STATUS_KEYS } from './personaStatusLabels'

/**
 * Kiest welke deelnemers een kaart toont, op grond van hun `Status`.
 *
 * Waarom dit een aparte keuze is: de aanwezigheidskaart haalde tot nu toe
 * alleen `Status == 'active'` op. Voor een jaaroverzicht klopt dat niet — wie
 * in maart uitstroomde heeft dat jaar wel degelijk meegedraaid, en zonder die
 * rijen mist een verantwoording precies de mensen die het traject afmaakten.
 *
 * De standaard blijft bewust 'alleen actief': dat is wat de kaart altijd al
 * liet zien, en het percentage bovenaan zou anders op ieders dashboard
 * veranderen zonder dat iemand erom vroeg.
 */

/** De keuze 'iedereen, ongeacht status'. */
export const ALL_PERSONA_STATUSES = 'all'

/** Waar een lege of onbekende keuze op terugvalt. */
const DEFAULT_STATUS = 'active'

/**
 * @param {Array<object>|null|undefined} personas - Deelnemersdocumenten
 * @param {string|null|undefined} selection - '' (alleen actief),
 *   `ALL_PERSONA_STATUSES`, of één sleutel uit `PERSONA_STATUS_KEYS`
 * @returns {Array<object>}
 */
const filterPersonasByStatus = (personas, selection) => {
    const list = Array.isArray(personas) ? personas : []

    if (selection === ALL_PERSONA_STATUSES) return list

    // Een waarde die geen bekende status is, komt uit een oud of half
    // geschreven kaartdocument. Dan liever te weinig tonen dan te veel.
    const status = PERSONA_STATUS_KEYS.includes(selection) ? selection : DEFAULT_STATUS

    return list.filter((persona) => persona?.Status === status)
}

export default filterPersonasByStatus
